import formCheck from '../forms/check/_index';
import csrf from '../utils/_csrf';

class mAjaxForm extends HTMLFormElement {
    constructor() {
        super();
        this.sourceName = this.dataset.sourcename;
        this.mandatoryFields = this.dataset.flgth;
        this.hideFormAfterSubmission = this.dataset.hideFormAfterSubmission;

        // These three variables are used to know when the validation of the form is done
        this.nbFieldsCheck = 0;
        this.checkInProgress = false;
        this.nbCheckedFields = 0;

        this.gtm = document.querySelector('[is="o-gtm"]');

        if (this.sourceName) {
            this.formData = this.querySelectorAll(`[data-components-${this.sourceName}-fields]`);
            this.formValid = this.querySelectorAll(`[data-components-${this.sourceName}-valid]`); // submit button
            this.btnsAction = this.querySelectorAll(`[data-components-${this.sourceName}-btn]`);
            this.popinButton = this.querySelectorAll('[data-popin]:not(template)');
            this.ctrl = this.querySelectorAll(`[data-components-${this.sourceName}-ctrl]`);
            this.extendedData = {
                action: this.action,
                name: this.name,
                id: this.id,
                sourceName: this.sourceName,
                mandatory: this.mandatoryFields,
            };
        } else {
            console.log(`ERROR: No sourcename found for ${this.name}`); // TODO Remove before MEP
        }

        // this binding
        this.selectValidityCheckEventer = this.selectValidityCheckEventer.bind(this);
        this.radioValidityCheckEventer = this.radioValidityCheckEventer.bind(this);
        this.onBrowserAutofill = this.onBrowserAutofill.bind(this);
        this.clearFormMessage = this.clearFormMessage.bind(this);
    }

    connectedCallback() {
        if (this.sourceName) {
            // Count the number of fields that will be checked. This is done before the setDataFormEvents call to prevent
            // strange behaviour due to asynchronous call with dispatchEvent.
            this.formData.forEach((el) => {
                if (el.type !== 'hidden' && !Object.hasOwnProperty.call(el.dataset, 'nounitchk')) {
                    this.nbFieldsCheck += 1;
                }
            });
            if (Object.hasOwnProperty.call(this.dataset, 'validateAllFields')) {
                this.ctrl.value = true;
                this.checkInProgress = true;
            }
            this.formData.forEach((el) => {
                // functional validation
                this.setDataFormEvents(el);
                // visual floating label
                // FIXME: The following code should be skipped for hidden inputs
                this.setActiveInput(el); // first init call
                el.addEventListener('input', this.setActiveInput); // on input callback
            });
            this.btnsAction.forEach((btnAction) => {
                btnAction.addEventListener('click', () => {
                    this.setInputBtnAction(btnAction);
                });
            });
            if (this.formValid && this.formValid.length > 0) {
                this.formValid.forEach((formValid) => {
                    formValid.addEventListener('click', (e) => {
                        this.setValidFormEvent(e);
                    });
                });
            }
            if (this.popinButton && this.popinButton.length > 0) {
                this.popinButton.forEach((btn) => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.makeModal(e);
                    });
                });
            }
        } else {
            console.log('ERROR: No sourcename found'); // TODO Remove before MEP
        }

        this.setFormEvents();

        this.addEventListener('submit', this.onSubmit);
        document.addEventListener('mAjaxForm:clearFormMessage', this.clearFormMessage);

        this.setCustomBehavior();
    }

    setCustomBehavior() {
        // Custom for newsletter
        if (this.sourceName && this.sourceName === 'nl' || this.sourceName === 'bis' || this.sourceName === 'opt') {
            const emailField = this.querySelector(`#${this.sourceName}-form-email`);
            const phoneField = this.querySelector(`#${this.sourceName}-register-phonenr`);
            const consentCheckbox = this.querySelector(`#${this.sourceName}-form-nlSubscriptionConsent`);
            const consentSmsCheckbox = this.querySelector(`#${this.sourceName}-form-nlSmsSubscriptionConsent`);
            const consentLVMHCheckbox = this.querySelector(`#${this.sourceName}-form-pointInterestSubscriptionConsent`);
            if (emailField) {
                const onEmailChange = () => {
                    if (emailField.value === '' || !emailField.checkValidity()) {
                        consentCheckbox?.setAttribute('disabled', '');
                        consentLVMHCheckbox?.setAttribute('disabled', '');
                    } else {
                        if (consentCheckbox?.dataset.emailSubscribed && consentCheckbox.dataset.emailSubscribed === 'null') {
                            consentCheckbox.removeAttribute('disabled');
                        }

                        if (consentLVMHCheckbox?.dataset.pointOfInterestSubscribed && consentLVMHCheckbox.dataset.pointOfInterestSubscribed === 'null') {
                            consentLVMHCheckbox.removeAttribute('disabled');
                        }
                    }
                };
                emailField.addEventListener('change', onEmailChange);
                onEmailChange();
            }

            if (phoneField) {
                const onPhoneChange = () => {
                    if (phoneField.value === '' || !phoneField.checkValidity()) {
                        consentSmsCheckbox?.setAttribute('disabled', '');
                    } else if (!consentSmsCheckbox.dataset.smsSubscribed) {
                        consentSmsCheckbox.removeAttribute('disabled');
                    }
                };

                phoneField.addEventListener('change', onPhoneChange);
                onPhoneChange();
            }
        }
    }

    /*
     Prevent form to be submitted with an other button than the form valid button
     */
    onSubmit(e) { e.preventDefault(); }

    /**
     * This method is called when a form field is checked. If a check is in progress (at the page's load when all fields
     * have to be validated and when form:validateFields is triggered), we see if all the form fields have been checked.
     * In this case, we call the validationDone method.
     */
    fieldChecked() {
        if (this.checkInProgress) {
            this.nbCheckedFields += 1;
            if (this.nbCheckedFields === this.nbFieldsCheck) {
                this.validationDone();
                this.checkInProgress = false;
                this.nbCheckedFields = 0;
            }
        }
    }

    /**
     * This method is called when all fields have been checked during a validation
     */
    validationDone() {
        // Manage what to do when validation is done
        if (this.ctrl.value === 'false' && this.dataset.validationOnLoad && this.dataset.eventOnError) {
            const fieldsInErrors = this.querySelectorAll('.error input, .error select, .error textarea');
            this.dispatchEvent(new CustomEvent(this.dataset.eventOnError, { detail: { fieldsInErrors } }));
        }
    }

    /**
     * Set specifics events for the form
     */
    setFormEvents() {
        this.addEventListener('form:validateFields', () => {
            this.validateFormFields();
        });

        this.addEventListener('form:validateField', (e) => {
            this.triggerCheckEvent(e.detail.field, !e.detail.allowEmpty, e.detail.triggerInput);
        });
    }

    /**
     * Set the visual floating label styles with is-active class
     * @param {HTMLElement|InputEvent} e current element or InputEvent trigger in addEventListenerCallback
     */
    setActiveInput(e) {
        let input = '';
        if (e instanceof Event) {
            input = e.currentTarget;
        } else {
            input = e;
        }

        const inputType = input.type.toLowerCase();
        let fieldParent = '';

        if (!['tel', 'radio', 'checkbox', 'select-one', 'select'].includes(inputType)) {
            if (input.closest('.form-field')) {
                fieldParent = input.closest('.form-field');
            } else {
                fieldParent = input.closest('div');
            }

            if (input.value) {
                fieldParent.classList.add('is-active');
            } else {
                fieldParent.classList.remove('is-active');
            }
        }

        if (inputType === 'textarea') {
            if (input.closest('.type-textarea')) {
                fieldParent = input.closest('.type-textarea');
            } else {
                fieldParent = input.closest('div');
            }
            const characterCounter = fieldParent.querySelector('.character-current');

            const numOfEnteredChars = input.value.length;
            characterCounter.textContent = numOfEnteredChars;
        }
    }

    setInputBtnAction(btnAction) {
        const btnSpan = btnAction.querySelector('span');
        const fieldParent = btnAction.closest('.form-field');

        if (fieldParent.classList.contains('type-password')) {
            const inputPassword = fieldParent.querySelector('input');
            const toggleType = inputPassword.getAttribute('type') === 'password' ? 'text' : 'password';
            const toggleButton = btnAction.getAttribute('aria-pressed') === 'false' ? 'true' : 'false';
            const hideTextButton = btnAction.getAttribute('data-hide-text');
            const showTextButton = btnAction.getAttribute('data-show-text');

            btnAction.setAttribute('aria-pressed', toggleButton);
            inputPassword.setAttribute('type', toggleType);

            if (toggleButton === 'true') {
                btnSpan.innerHTML = hideTextButton;
                btnAction.classList.add('active');
            } else {
                btnSpan.innerHTML = showTextButton;
                btnAction.classList.remove('active');
            }
        }
    }

    /**
     * Default validity check for input
     * @param {Node} currentElement current element
     * @param {Event} event event
     */
    defaultValidityCheckEvent(currentElement, event) {
        let restricted = false;
        if (event.type === 'keyup') {
            restricted = formCheck.restrictedKeyUp(event, currentElement);
        }
        if (!restricted) {
            this.checkConfirmValidity(currentElement);
            const valid = currentElement.checkValidity();
            if (valid) {
                formCheck.manageValidationValid(currentElement);
                if (Object.hasOwnProperty.call(currentElement.dataset, 'triggerEventValid')) {
                    currentElement.dispatchEvent(new CustomEvent(currentElement.dataset.triggerEventValid), {
                        value: currentElement.value,
                    });
                }
            } else {
                formCheck.manageValidationError(currentElement, this.ctrl);
            }
        }
        // after first initial check (either via user input or prefilled field),
        // we'll remove the 'change' listener that evaluates after user leave the field,
        // to switch to a 'input' listener that will revalidate on each key press
        if (!currentElement.dataset.firstCheckDone) {
            currentElement.removeEventListener('change', this.defaultValidityCheckEventer);
            currentElement.addEventListener('input', this.defaultValidityCheckEventer);
            // eslint-disable-next-line no-param-reassign
            currentElement.dataset.firstCheckDone = true;
        }
    }

    /**
     * Validity check for select
     * @param {Node} currentElement current element
     * @param {Node} control control input
     * @param {Event} event event
     */
    selectValidityCheckEvent(currentElement, control, event) {
        let restricted = false;
        if (event.type === 'keyup') {
            restricted = formCheck.restrictedKeyUp(event, currentElement);
        }
        if (!restricted) {
            const check = formCheck.testFormField(currentElement);
            if (!check) {
                formCheck.manageValidationError(currentElement, control);
            } else {
                formCheck.manageValidationValid(currentElement);
            }
        }
    }

    /**
     * Static function
     * Trigger a validity error if elem value is different from the targeted
     * element value pointed by their "data-confirm-of" attribut (if present)
     * @param {Node} elem an HTML element
     */
    checkConfirmValidity(elem) {
        if (!('confirmOf' in elem.dataset)) return;

        elem.setCustomValidity(''); // reset confirm error
        const confirmOfElem = document.getElementById(elem.dataset.confirmOf);
        if (!confirmOfElem) return;

        if (confirmOfElem.value !== elem.value) {
            const errorMessage = 'confirmError' in elem.dataset
                ? elem.dataset.confirmError
                : 'error.message.mismatch';
            elem.setCustomValidity(errorMessage);
        }
    }

    /**
     * Static function
     * On confirm type inputs, add an event listener on targeted element
     * to update its own validity
     * @param {Node} confirmElem an HTML element
     */
    addConfirmListeners(confirmElem) {
        if (!('confirmOf' in confirmElem.dataset)) return;

        const targetElem = document.getElementById(confirmElem.dataset.confirmOf);
        if (!targetElem) return;

        targetElem.addEventListener('input', (e) => {
            if (!confirmElem.dataset.firstCheckDone) return;

            const form = e.currentTarget.closest('form');
            form.defaultValidityCheckEvent(confirmElem, new CustomEvent('confirm_change'));
            form.fieldChecked();
        });
    }

    /**
     * Static function
     * This function sets depending on HTML Element Type the event behavior
     * We rely on ctrl.value in order to manage correctly the form
     * We do not test hidden fields and fields that are marked specifically to not be testes uniquely data-nounitchk attribute written for html form field
     * @param {HTMLFormElement} currentElement the form element
     */
    setDataFormEvents(currentElement) {
        const validateAllFields = Object.hasOwnProperty.call(this.dataset, 'validateAllFields');
        if (currentElement.type !== 'hidden' && !Object.hasOwnProperty.call(currentElement.dataset, 'nounitchk')) {
            this.addConfirmListeners(currentElement);
            switch (currentElement.type.toLowerCase()) {
                case 'radio':
                    currentElement.addEventListener('change', this.radioValidityCheckEventer);
                    break;
                case 'select':
                case 'select-one':
                    currentElement.addEventListener('change', this.selectValidityCheckEventer);
                    break;
                case 'tel':
                    // Should be handle by m-phone-field
                    break;
                default:
                    currentElement.addEventListener('change', this.defaultValidityCheckEventer);
                    // Specific event for webkit autofillable/autocomplete fields
                    // see : https://stackoverflow.com/questions/11708092/detecting-browser-autofill
                    // JS side : https://github.com/klarna/ui/blob/v4.10.0/Field/index.jsx#L104-L114
                    // CSS side : https://github.com/klarna/ui/blob/v4.10.0/Field/styles.scss#L228-L241
                    if (currentElement.hasAttribute('autocomplete')) {
                        currentElement.addEventListener('animationstart', this.onBrowserAutofill);
                    }
            }
            // trigger a check event if value is not null or if value is empty and the form has the validateAllFields dataset attribute
            this.triggerCheckEvent(currentElement, validateAllFields);
        } else if (currentElement.type === 'hidden') {
            if (currentElement.attributes.required && !Object.hasOwnProperty.call(currentElement.dataset, 'nocount')) {
                formCheck.manageSubmitButtonDisability(currentElement, true);
            }
        }
    }

    onBrowserAutofill(e) {
        if (e.animationName === 'onAutoFillStart') {
            // webkit give you access to autofilled value
            // only if the user interacted with the page, see :
            // https://stackoverflow.com/questions/34098975/getting-the-value-of-autofilled-inputs-jquery#comment-102209088
            // (security issue) so we cannot validate the field when the layer url like
            // https://dev03-eu01-kenzo.demandware.net/s/KENZO_FR/home?rurl=1&layer=login
            e.srcElement.closest('.form-field').classList.add('is-active');
        }
    }

    radioValidityCheckEventer(e) {
        formCheck.manageRadioCheck(e.currentTarget, this, this.ctrl);
        this.fieldChecked();
    }

    selectValidityCheckEventer(e) {
        if (e.currentTarget.closest('.birthday') !== null) { //
            // specific birthday validation
            const control = this.ctrl;
            const { sourceName } = this.extendedData;
            const dataForm = this.formData;
            const birthdayFields = formCheck.findBirthdayFields(dataForm);

            if (birthdayFields.valid) {
                formCheck.checkBirthday(birthdayFields, control, sourceName, true);
            }
        } else {
            // standard <select> validation
            this.selectValidityCheckEvent(e.currentTarget, this.ctrl, e.type);
            this.fieldChecked();
        }
    }

    defaultValidityCheckEventer(e) {
        const form = e.currentTarget.closest('form');
        form.defaultValidityCheckEvent(e.currentTarget, window.event);
        form.fieldChecked();
    }

    /**
     * Check all fields of the form by triggering each field. This will update the submit button according to the validity of the fields
     */
    validateFormFields() {
        this.checkInProgress = true;
        this.ctrl.value = 'true';
        this.formData.forEach((currentElement) => {
            if ('noManualValidation' in currentElement.dataset) {
                return;
            }
            if (currentElement.type !== 'hidden' && !Object.hasOwnProperty.call(currentElement.dataset, 'nounitchk')) {
                this.triggerCheckEvent(currentElement, true);
            } else if (currentElement.type === 'hidden') {
                if (currentElement.attributes.required && !Object.hasOwnProperty.call(currentElement.dataset, 'nocount')) {
                    formCheck.manageSubmitButtonDisability(currentElement, true);
                }
            }
        });
    }

    /**
     * This function triggers an event if the field is either having a value or being checked
     * @param {HTMLElement} htmlElement the current HTML Element
     * @param {boolean} noEmpty is an empty field has to be triggered
     * @param triggerInput
     */
    triggerCheckEvent(htmlElement, noEmpty, triggerInput) {
        let triggerEvent = false;
        if (htmlElement && htmlElement.type) {
            switch (htmlElement.type) {
                case 'checkbox':
                case 'radio':
                    if (htmlElement.checked) {
                        triggerEvent = true;
                    }
                    break;
                case 'select':
                case 'select-one':
                    var possibleValues = ['select', ''];
                    if (possibleValues.indexOf(htmlElement.value) === -1) {
                        triggerEvent = true;
                    }
                    break;
                default:
                    if (htmlElement.value !== '') {
                        triggerEvent = true;
                    }
            }
            if (triggerEvent || (noEmpty && htmlElement.attributes.required)) {
                let event = new Event('change');
                htmlElement.dispatchEvent(event);
                if (triggerInput) {
                    event = new Event('input');
                    htmlElement.dispatchEvent(event);
                }
            } else {
                this.fieldChecked();
            }
        }
    }

    setFormMessage(type, messageHtml) {
        let formMessage = document.getElementById(`${this.sourceName}-form-message`);
        if (type === 'success' && document.getElementById(`${this.sourceName}-form-message-valid`)) {
            formMessage = document.getElementById(`${this.sourceName}-form-message-valid`);
        }
        if (!formMessage) return;
        formMessage.classList.remove('success', 'error');
        formMessage.classList.add(type);
        formMessage.innerHTML = messageHtml;
    }

    clearFormMessage() {
        const formMessage = document.getElementById(`${this.sourceName}-form-message`);
        if (!formMessage) return;
        formMessage.classList.remove('success', 'error');
        formMessage.innerHTML = '';
    }

    /**
     * This function holds all actions to perform when formular is submitted :
     * coherence controls
     * submission with management of the backend answer
     * @param {Event} e the current event
     */
    setValidFormEvent(e) {
        e.preventDefault();
        const control = this.ctrl;
        control.value = 'true';
        const { sourceName } = this.extendedData;
        const dataForm = this.formData;
        // Check first if all fields are correctly filled
        for (let fields = 0; fields < dataForm.length; fields++) {
            if (dataForm[fields].type !== 'hidden' && !Object.hasOwnProperty.call(dataForm[fields].dataset, 'nounitchk')) {
                // error detection event listener is either set on 'input' or 'change'
                // depending on what the user has done
                dataForm[fields].dispatchEvent(new CustomEvent('change', { detail: { validFormEvent: true } }));
                dataForm[fields].dispatchEvent(new Event('input'));
            }
        }

        // Specific check to be performed. Make sure first that the required fields are available from the dataForm
        const birthdayFields = formCheck.findBirthdayFields(dataForm);

        if (birthdayFields.valid) {
            formCheck.checkBirthday(birthdayFields, control, sourceName, false);
        }
        const checkFormValidity = (areBirthdayFields) => {
            const areFieldsValid = [...dataForm].filter((input) => input.ariaInvalid).every((input) => input.ariaInvalid === 'false');
            const isNumBirthday = areBirthdayFields ? !Object.values(birthdayFields).filter((field) => field.value && isNaN(parseInt(field.value, 10))).length : true;
            const isBirthdayValid = areBirthdayFields ? document.getElementById('bdErrorMsg').innerHTML === '' : true;
            return (isNumBirthday && isBirthdayValid && areFieldsValid);
        };

        // AJAX Call if everything Okay (and there is no data-no-fetch)
        if (checkFormValidity(birthdayFields.valid) && this.extendedData && this.extendedData.action && control.value === 'true' && this.dataset.noFetch === undefined) {
            this.clearFormMessage();
            e.target.disabled = true;
            csrf.refreshCsrfToken(this).then(() => fetch(this.extendedData.action, {
                method: 'POST',
                body: new FormData(document.getElementById(this.extendedData.id)),
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            }).then((response) => response.json()).then((responseData) => {
                if (responseData.success) {
                    // GTM
                    if (responseData.gtmData && this.gtm) {
                        const { gtmData } = responseData;
                        const gtmEvents = Array.isArray(gtmData) ? gtmData : [gtmData];
                        gtmEvents.forEach((gtmEvent) => {
                            if (gtmEvent.pushEvent) {
                                this.gtm.pushEvent(gtmEvent);
                            } else {
                                this.gtm.ajaxEvent(gtmEvent);
                            }
                        });
                    }

                    // checks for redirect url
                    if (responseData.redirectUrl) {
                        location.href = responseData.redirectUrl;
                    } else {
                        e.target.disabled = false;
                    }
                    // display success message
                    if (responseData.message) {
                        this.setFormMessage('success', responseData.message);
                    }
                    // hide form if needed
                    if (this.hideFormAfterSubmission) {
                        if (this.hideFormAfterSubmission === 'close-reveal') {
                            this.querySelectorAll('[is="m-reveal"]').forEach((elem) => {
                                elem.toggleContent(false);
                            });
                        } else {
                            this.closest('div').classList.add('send-success');
                            this.classList.add('d-none');
                        }
                    }
                }

                if (responseData.error) {
                    e.target.disabled = false;
                    // Manage Backend error messages
                    // Backend Messages have to match following pattern :
                    /* TODO
                    var message = {
                        success: <boolean>,
                        error: <boolean>,
                        message: <JSONObject> or <string>,
                        data: '' // not used for the moment?
                    };
                    */
                    this.setFormMessage('error', responseData.message ? responseData.message : 'ERROR');
                }
            }));
        } else {
            e.target.disabled = false;
            // set focus to first field that is on error
            const firstErrorInput = this.querySelector('.error input, .error select, .error textarea');
            if (firstErrorInput) {
                const formFieldContainer = firstErrorInput.closest('.form-field');
                const formIsInsideSidebar = firstErrorInput.closest('.slide-panel');

                if (formCheck.isVisible(formFieldContainer) && formFieldContainer) {
                    if (formIsInsideSidebar) {
                        formCheck.scrollIntoViewWithOffset(formFieldContainer, formIsInsideSidebar);
                    } else {
                        formCheck.scrollIntoViewWithOffset(formFieldContainer);
                    }

                    setTimeout(() => { // wait until the smooth scroll behaviour is done otherwise it can break the scroll effect
                        firstErrorInput.focus();
                    }, 800);
                }
            }
        }
        // Trigger event if form is valid for checkout
        if (checkFormValidity(birthdayFields.valid) && control.value === 'true' && this.dataset.eventOnValidation) {
            this.clearFormMessage();
            this.dispatchEvent(new CustomEvent(this.dataset.eventOnValidation));
        }
        if (!checkFormValidity(birthdayFields.valid) && control.value === 'false' && this.dataset.eventOnError) {
            const fieldsInError = this.querySelectorAll('.error input, .error select, .error textarea');
            // Debug log form error fields ; DO NOT COMMIT UNCOMMENTED
            // console.log('m-ajax-form: Fields in Error: ');
            // console.dir(fieldsInError);
            this.dispatchEvent(new CustomEvent(this.dataset.eventOnError, { detail: { fieldsInError } }));
        }
    }

    makeModal(e) {
        // Clone remove product modal template
        const template = document.querySelector(`template[data-popin="${e.currentTarget.dataset.popin}"]`);
        if (!template) {
            throw new Error('Missing template for modal');
        }
        const modalEl = template.content
            .querySelector('[is="m-popin"]')
            .cloneNode(true);

        // Setup close callback
        modalEl.addEventListener('close', () => { modalEl.remove(); });

        // Toggle display
        document.body.appendChild(modalEl);
        // TODO: Find a better fix than setTimeout
        // Execute in the next event cycle to let the webcomponent load well; (https://developer.mozilla.org/en/docs/Web/API/setTimeout)
        setTimeout(() => {
            // TODO: modify popin to remove "toggling" behavior
            modalEl.togglePopin();
        });
    }
}

customElements.define('m-ajax-form', mAjaxForm, {
    extends: 'form',
});
